module.exports = __webpack_public_path__ + "static/media/amine2.820e8c56.webp";